const ru = {
  // Навигация
  nav_intro: 'О компании',
  nav_business: 'Наш бизнес',
  nav_events: 'Отраслевые мероприятия',
  nav_team: 'Наша команда',
  nav_achievements: 'Достижения',
  nav_contact: 'Связаться с нами',
  
  // Главная секция
  hero_main_title: 'Профессиональная торговля',
  hero_main_subtitle: 'Apple смартфонами',
  hero_company_intro: 'Hong Kong BOJM Trading Co., Ltd. основана в ',
  hero_company_year: '2011 году',
  hero_company_desc: ', специализируется на глобальной торговле смартфонами Apple.',
  hero_business_desc: 'Мы специализируемся на продаже ',
  hero_product_1: 'восстановленных Apple',
  hero_product_2: 'новых Apple',
  hero_product_3: 'б/у Apple',
  hero_business_coverage: ' смартфонов, наш бизнес охватывает Европу, Дубай, Латинскую Америку, Юго-Восточную Азию и другие мировые рынки.',
  hero_cta_contact: 'Связаться с нами',
  hero_cta_learn: 'Узнать больше',
  
  // О компании
  intro_title: 'О компании',
  intro_title_highlight: 'BOJM Trading',
  intro_company_name: 'Hong Kong BOJM Trading Co., Ltd.',
  intro_company_name_en: '香港博鑫貿易有限公司',
  intro_founded: 'Основана в ',
  intro_founded_year: '2011 году',
  intro_desc_1: ', мы являемся профессиональной компанией, специализирующейся на глобальной торговле смартфонами Apple. За более чем десятилетие развития мы стали надежным партнером в отрасли.',
  intro_desc_2: 'Мы специализируемся на продаже ',
  intro_desc_3: ' смартфонов. Благодаря богатому отраслевому опыту и обширной сети поставок, мы предоставляем качественные продукты и услуги клиентам по всему миру.',
  intro_stat_year: '2011',
  intro_stat_year_label: 'Год основания',
  intro_stat_coverage: '4+',
  intro_stat_coverage_label: 'Глобальных регионов',
  intro_experience: '13+',
  intro_experience_label: 'Лет опыта',
  
  // Бизнес
  business_title: 'Наш',
  business_title_highlight: 'Бизнес',
  business_subtitle: 'Специализируемся на глобальной торговле смартфонами Apple, предоставляя профессиональные услуги по продаже ',
  business_subtitle_bold_1: 'новых Apple',
  business_subtitle_bold_2: 'восстановленных Apple',
  business_subtitle_bold_3: 'б/у Apple',
  business_subtitle_end: ' смартфонов',
  
  business_new_title: 'Новые Apple смартфоны',
  business_new_desc: 'Новейшие продукты серии iPhone, совершенно новые и запечатанные, гарантия подлинности, с глобальной гарантийной службой.',
  business_new_feature_1: 'Новые запечатанные',
  business_new_feature_2: 'Подлинные',
  business_new_feature_3: 'Глобальная гарантия',
  
  business_resource_title: 'Восстановленные Apple',
  business_resource_desc: 'Качественные восстановленные телефоны, строго проверенные, выгодная цена, подходят для оптовых закупок и канального распространения.',
  business_resource_feature_1: 'Строгая проверка',
  business_resource_feature_2: 'Оптовые скидки',
  business_resource_feature_3: 'Канальные преимущества',
  
  business_used_title: 'Б/у Apple смартфоны',
  business_used_desc: 'Отборные качественные б/у iPhone, профессионально протестированные и восстановленные, надежное качество, доступная цена, лучший выбор по соотношению цена-качество.',
  business_used_feature_1: 'Профессиональное тестирование',
  business_used_feature_2: 'Гарантия качества',
  business_used_feature_3: 'Доступная цена',
  
  business_coverage_title: 'Глобальное покрытие бизнеса',
  business_coverage_subtitle: 'Наши продукты и услуги охватывают четыре основных мировых рынка',
  business_region_europe: 'Европа',
  business_region_europe_en: '歐洲',
  business_region_dubai: 'Дубай',
  business_region_dubai_en: '迪拜',
  business_region_latam: 'Латинская Америка',
  business_region_latam_en: '拉美',
  business_region_sea: 'Юго-Восточная Азия',
  business_region_sea_en: '東南亞',
  
  // Мероприятия
  events_title: 'Отраслевые',
  events_title_highlight: 'Мероприятия',
  events_subtitle: 'Активно участвуем в ',
  events_subtitle_bold: 'Гонконгской международной ассоциации коммуникационной электронной коммерции',
  events_subtitle_end: ' и других отраслевых организациях, поддерживая тесные связи с глобальными партнерами',
  
  events_event1_title: 'Ежегодный саммит HKICEC',
  events_event1_date: '13 ноября 2025',
  events_event1_desc: 'Церемония инаугурации и торжественный ужин прошли с большим успехом, в них приняли участие более 200 компаний-членов. Гонконг - Гонконгская международная ассоциация коммуникационной электронной коммерции (HKICEC), совместно инициированная лидерами отрасли, была официально создана 13 ноября 2025 года. Церемония инаугурации и торжественный ужин состоялись в Гонконгском конференц-выставочном центре (Новое крыло), что стало новой вехой для индустрии коммуникационной электронной коммерции Гонконга.',
  
  events_event2_title: 'Обменные мероприятия HKICEC',
  events_event2_date: '13 ноября 2025',
  events_event2_desc: 'Представители компаний-членов собрались вместе, чтобы обсудить тенденции развития отрасли и возможности сотрудничества. Мероприятие прошло в теплой атмосфере, представители различных компаний провели углубленный обмен мнениями о последних событиях, рыночных возможностях и будущих направлениях развития в области коммуникационной электронной коммерции.',
  
  events_tag_1: 'HKICEC',
  events_tag_2: 'Отраслевой саммит',
  events_tag_3: 'Международный обмен',
  events_member_badge: 'Член ассоциации',
  
  // Команда
  team_title: 'Наша',
  team_title_highlight: 'Команда',
  team_subtitle: 'Опытная управленческая команда, ведущая непрерывное развитие и инновации',
  
  team_ceo_name: 'Чжан Гуосун',
  team_ceo_position: 'Генеральный директор',
  team_ceo_desc: 'Более 20 лет опыта в индустрии мобильных телефонов, тесно сотрудничал с известными брендами, такими как Transsion и Xiaomi, обладает обширным опытом и широкими отраслевыми ресурсами в торговле мобильными телефонами.',
  
  team_sales_name: 'Ли Чэнжуй',
  team_sales_position: 'Директор по продажам и операциям',
  team_sales_desc: 'Отвечает за разработку стратегии продаж компании и управление операциями, руководит командой по расширению глобальных рынков, обеспечивая эффективную работу бизнеса и непрерывный рост.',
  
  // Достижения
  achievements_title: 'Наши',
  achievements_title_highlight: 'Достижения',
  achievements_subtitle: 'Постоянный рост показателей, свидетельствующий о нашей профессиональной силе и доверии рынка',
  
  achievements_last_year: '2 млрд',
  achievements_last_year_label: 'Продажи прошлого года',
  achievements_last_year_period: 'Годовые показатели продаж 2023',
  
  achievements_this_year: '5 млрд',
  achievements_this_year_label: 'Продажи этого года',
  achievements_this_year_period: 'Годовые показатели продаж 2024',
  
  achievements_growth_title: 'Годовой темп роста',
  achievements_growth_desc_1: 'С 2 млрд в 2023 году до 5 млрд в 2024 году, мы достигли удивительного роста в ',
  achievements_growth_rate: '150%',
  achievements_growth_desc_2: ', что полностью демонстрирует нашу конкурентоспособность на рынке и доверие клиентов.',
  achievements_year_2023: '2023',
  achievements_year_2024: '2024',
  achievements_growth_indicator: '+150%',
  
  achievements_stat_experience: '13+',
  achievements_stat_experience_label: 'Лет опыта',
  achievements_stat_markets: '4+',
  achievements_stat_markets_label: 'Глобальных рынков',
  achievements_stat_team: 'Профессиональная',
  achievements_stat_team_label: 'Управленческая команда',
  achievements_stat_quality: 'Качество',
  achievements_stat_quality_label: 'Продукты и услуги',
  
  // Контакты
  contact_title: 'Связаться',
  contact_title_highlight: 'с нами',
  contact_intro: 'Свяжитесь с нами, мы предоставим вам профессиональные консультационные услуги и качественные решения для продуктов.',
  
  contact_address_title: 'Адрес компании',
  contact_address_value: 'Комната 2021, №1 Hung To Road, Kwun Tong, Гонконг',
  contact_address_value_en: '香港觀塘區鴻圖道1號2021室',
  
  contact_phone_title: 'Телефон',
  contact_phone_value: '+852 6468 5009',
  
  contact_email_title: 'Email',
  contact_email_value: 'dragonlee03@163.com',
  
  contact_coverage_title: 'Покрытие бизнеса',
  contact_coverage_value: 'Европа · Дубай · Латинская Америка · Юго-Восточная Азия',
  
  contact_hours_title: 'Рабочие часы',
  contact_hours_value: 'Понедельник - Пятница 9:00 - 18:00',
  
  contact_form_name: 'Имя',
  contact_form_name_placeholder: 'Введите ваше имя',
  contact_form_email: 'Email',
  contact_form_email_placeholder: 'Введите ваш email',
  contact_form_phone: 'Телефон',
  contact_form_phone_placeholder: 'Введите ваш телефон',
  contact_form_company: 'Название компании',
  contact_form_company_placeholder: 'Введите название вашей компании',
  contact_form_message: 'Сообщение',
  contact_form_message_placeholder: 'Введите ваше сообщение',
  contact_form_submit: 'Отправить',
  contact_form_submitting: 'Отправка...',
  contact_form_success: 'Успешно отправлено! Мы свяжемся с вами в ближайшее время.',
  contact_form_error: 'Ошибка отправки, попробуйте позже.',
  contact_form_char_limit: '/500',
  
  // Футер
  footer_company_name: 'Hong Kong BOJM Trading Co., Ltd.',
  footer_company_name_en: '香港博鑫貿易有限公司',
  footer_company_desc: 'Специализируемся на глобальной торговле смартфонами Apple, предоставляя качественные продукты и профессиональные услуги клиентам.',
  
  footer_quick_links: 'Быстрые ссылки',
  footer_link_about: 'О нас',
  footer_link_business: 'Наш бизнес',
  footer_link_team: 'Наша команда',
  footer_link_achievements: 'Достижения',
  footer_link_contact: 'Контакты',
  
  footer_products_title: 'Продукты',
  footer_product_new: 'Новые Apple',
  footer_product_resource: 'Восстановленные Apple',
  footer_product_used: 'Б/у Apple',
  
  footer_regions_title: 'Регионы покрытия',
  footer_region_europe: 'Европа',
  footer_region_dubai: 'Дубай',
  footer_region_latam: 'Латинская Америка',
  footer_region_sea: 'Юго-Восточная Азия',
  
  footer_copyright: '© 2024 Hong Kong BOJM Trading Co., Ltd. 香港博鑫貿易有限公司 Все права защищены',
  footer_powered: 'Powered by Readdy',
};

export default ru;
